/**
 * Token const exports for runtime access (SVG attrs, inline styles where Tailwind
 * doesn't apply, JS-side colour calculations). Mirrors tokens.css 1:1.
 *
 * Discipline: this file is the ONLY allowed source of hex literals in app code.
 * Do not re-type these in components; import { tokens } and read from here.
 */
export const tokens = {
    surface: {
        paper: "#F5F1EA",
        paperWarm: "#FAF7F2",
        ivory: "#FBF9F4",
        white: "#FFFFFF",
    },
    ink: {
        900: "#1A1614",
        700: "#3F3933",
        500: "#7A7268",
        400: "#A39B8E",
        300: "#C2BBB0",
        200: "#D6D1C8",
        100: "#E8E3D9",
    },
    accent: {
        olive: "#5C6B3B",
        oliveTint: "#788849",
        oliveSoft: "#EFEFE5",
        oliveDeep: "#404B27",
    },
    semantic: {
        success: "#3F6E3D",
        successSoft: "#E5EDE3",
        warning: "#A86E1B",
        warningSoft: "#F2E9D6",
        danger: "#A4322C",
        dangerSoft: "#F0DAD8",
        info: "#3A5A78",
        infoSoft: "#DDE5EC",
    },
    // P09-T20 tier-discount badge palette. Mirrors tokens.css; see comment there.
    tier: {
        standard: "#5C6B3B",
        standardSoft: "#EFEFE5",
        bronze: "#8B5A2B",
        bronzeSoft: "#F4E8DC",
        silver: "#6B6B6B",
        silverSoft: "#ECECEC",
        gold: "#8C6A1F",
        goldSoft: "#F4ECDA",
    },
    radius: {
        xs: "2px",
        sm: "4px",
        md: "8px",
        pill: "9999px",
    },
    shadow: {
        1: "0 1px 2px rgba(26, 22, 20, 0.04)",
        2: "0 4px 12px rgba(26, 22, 20, 0.06)",
        3: "0 16px 32px rgba(26, 22, 20, 0.08)",
        focus: "0 0 0 3px rgba(92, 107, 59, 0.25)",
    },
    font: {
        serif: '"Fraunces", "Cormorant Garamond", Georgia, serif',
        sans: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
    },
};
